var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll_container"},[(_vm.flag)?_c('div',{staticClass:"scroll_loading"},[_c('van-icon',{attrs:{"name":"replay"}})],1):_vm._e(),_c('div',{ref:"wrapper",staticClass:"wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }